export default __webpack_public_path__ + "static/media/Rectangle 407.16cd8bb5.png";